<template>
  <div>
    <header>
      <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
        <div class="container-fluid">
          <a class="navbar-brand" href="#">Manufacturing Multi-Organs (MM)</a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav me-auto mb-2 mb-auto">
              <li class="nav-item">
                <a class="nav-link" @click="routePush('/')">Home</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="routePush('/organs')">Organs</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="routePush('/models')">Models</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="routePush('/materials')">Materials</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://gulab.info/about/">About</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" @click="routePush('/visitors')">Visitors</a>
              </li>
            </ul>
            <form class="d-flex">
              <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
              <button class="btn btn-outline-light" onmouseover="this.style.backgroundColor='black';" onmouseout="this.style.backgroundColor='';"
                      type="submit" style="color:white">Search</button>
            </form>
          </div>
        </div>
      </nav>
    </header>
    <div style="position: relative; margin-top:56px">
      <div class="count-box">
        <h2>Visitors</h2>
        <div class="map-wrap">
          <div ref="chart" class="chart-map"></div>
          <div class="legend">
            <div>
              <p>
                {{ toThousands(visitNum) }}
              </p>
              <p>Visits</p>
            </div>
            <div>
              <p>
                {{ toThousands(ipNum) }}
              </p>
              <p>Access IPs</p>
            </div>
            <div>
              <p>
                {{ toThousands(countryNum) }}
              </p>
              <p>Countries</p>
            </div>
          </div>
        </div>
      </div>
      <div style="width:100%;">
        <footer class="py-4 bg-light mt-auto" style="text-align: center; padding-left:3%; width:100%; position: fixed; bottom: 0">
          <div class="container-fluid px-4">
            <div class="d-flex align-items-center justify-content-between small">
              <div class="text-muted">Copyright &copy; Group of Bioinspired Engineering 2023</div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "../assets/js/worldAndChina";
import { getVisitsCount } from "@/request/visitors";

export default {
  name: "echarts",
  data() {
    return {
      laguage: "En",
      map: {},
      myEcharts: null,
      visitNum: 0,
      ipNum: 0,
      countryNum: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.myEcharts) {
        this.myEcharts = echarts.init(this.$refs.chart);
        this.myEcharts.off("click");
        this.myEcharts.on("click", this.handleClick);
        window.addEventListener("resize", this.resize, true);
      }
      this.initChart();
    });
    getVisitsCount({}).then(res => {
      this.$nextTick(() => {
        this.map = res['maplist'];
        this.visitNum = res['visits'];
        this.ipNum = res['ips'];
        this.countryNum = res['countries'];
        this.initChart(res['maplist']);
      });
    });

  },
  methods: {
    routePush(path){
      this.$router.push({ path:path })
    },
    initChart(data) {
      data = data || {
        listCity: [
          {
            name: "加拿大",
            value: 199,
          },
          {
            name: "利比亚",
            value: 42,
          },
          {
            name: "俄罗斯",
            value: 102,
          },
          {
            name: "英国",
            value: 2,
          },
          {
            name: "纽约州",
            value: 2,
          },
          {
            name: "俄亥俄州",
            value: 2,
          },
          {
            name: "美国",
            value: 2,
          },
          {
            name: "新罕布什尔州",
            value: 2,
          },
          {
            name: "加州",
            value: 2,
          },
          {
            name: "法国",
            value: 2,
          },
          {
            name: "巴西",
            value: 2,
          },
        ],
        geoCoordMap: {
          芬兰: [241.909912, 60.169095],
          美国: [-97.822, 37.751],
          纽约州: [-78.8927, 42.8867],
          日本: [139.710164, 35.706962],
          韩国: [126.979208, 37.53875],
          瑞士: [7.445147, 46.956241],
          东南亚: [117.53244, 5.300343],
          澳大利亚: [135.193845, -25.304039],
          德国: [13.402393, 52.518569],
          英国: [-0.1224, 51.4964],
          加拿大: [-102.646409, 59.994255],
          利比亚: [13.07, 32.49],
          俄罗斯: [37.35, 55.45],
          俄亥俄州: [-83.0061, 39.9625],
          加州: [-121.7946, 37.2379],
          新罕布什尔州: [-71.5786, 42.7514],
          法国: [-2.9366964, 40.3438963],
          巴西: [-36.479705, -7.902402],
        },
      };
      let nameMap = {
        阿富汗: "Afghanistan",
        多米尼克: "Dominica",
        巴巴多斯: "Barbados",
        格林纳达: "Grenada",
        圣卢西亚: "Saint Lucia",
        圣文森特和格林纳丁斯: "Saint Vincent and the Grenadines",
        美属维尔京群岛: "United States Virgin Islands",
        马尔维纳斯群岛: "Malvinas Islands",
        英国: "Britain",
        捷克: "Czech Republic",
        约旦: "Jordan",
        格鲁吉亚: "Georgia",
        阿富汗伊斯兰共和国: "Islamic Republic of Afghanistan",
        巴勒斯坦: "Palestine",
        阿拉伯撒哈拉民主共和国: "Sahrawi Arab Democratic Republic",
        也门: "Yemen",
        阿拉伯联合酋长国: "United Arab Emirates",
        安哥拉共和国: "Angola",
        阿尔巴尼亚共和国: "Albania",
        阿尔及利亚: "Algeria",
        阿根廷: "Argentina",
        亚美尼亚: "Armenia",
        澳大利亚: "Australia",
        奥地利: "Austria",
        阿塞拜疆: "Azerbaijan",
        巴哈马: " Bahamas ",
        孟加拉国: "Bangladesh",
        比利时: " Belgium ",
        贝宁: "Benin",
        布基纳法索: "Burkina Faso",
        布隆迪: " Burundi",
        保加利亚: "Bulgaria",
        波斯尼亚和黑塞哥维那: "Bosnia and Herz",
        白俄罗斯: "Belarus",
        伯利兹: "Belize",
        百慕大群岛: "Bermuda",
        玻利维亚: "Bolivia",
        巴西: "Brazil",
        文莱: "Brunei ",
        不丹: "Bhutan",
        博茨瓦纳: "Botswana",
        柬埔寨: "Cambodia",
        喀麦隆: "Cameroon",
        加拿大: "Canada",
        中非: "Central African Rep.",
        乍得: "Chad",
        智利: "Chile",
        中国: "China",
        哥伦比亚: "Colombia",
        刚果民主共和国: "Democratic Republic of the Congo",
        "刚果（金）": "Congo",
        哥斯达黎加: "Costa Rica",
        科特迪瓦: "Côte d'Ivoire",
        克罗地亚: "Croatia ",
        古巴: "Cuba",
        塞浦路斯: "Cyprus",
        捷克共和国: "CzechRep",
        韩国: "Dem.Rep.Korea",
        "刚果（布）": "Dem. Rep. Congo",
        丹麦: "Denmark",
        吉布提: "Djibouti",
        多米尼加: "Dominican Rep.",
        厄瓜多尔: "Ecuador",
        埃及: "Egypt",
        萨尔瓦多: "ElSalvador",
        赤道几内亚: "Eq.Guinea",
        厄立特里亚: "Eritrea",
        爱沙尼亚: "Estonia",
        埃塞俄比亚: "Ethiopia",
        福克兰群岛: "FalklandIs",
        斐济: "Fiji",
        芬兰: "Finland",
        法国: "France",
        法属圭亚那: "FrenchGuiana",
        法属南部领地: "Fr.S.AntarcticLands",
        加蓬: "Gabon",
        冈比亚: "Gambia",
        德国: "Germany",
        佐治亚州: "Georgia ",
        加纳: "Ghana",
        希腊: "Greece",
        格陵兰: "Greenland",
        危地马拉: "Guatemala",
        几内亚: "Guinea",
        几内亚比绍: "Guinea-Bissau",
        圭亚那: "Guyana",
        海地: "Haiti",
        赫德岛和麦克唐纳群岛: "HeardI.andMcDonaldIs",
        洪都拉斯: "Honduras",
        匈牙利: "Hungary",
        冰岛: "Iceland",
        印度: "India",
        印度尼西亚: "Indonesia",
        伊朗: "Iran",
        伊拉克: "Iraq",
        爱尔兰: "Ireland",
        以色列: "Israel",
        意大利: "Italy",
        象牙海岸: "IvoryCoast",
        牙买加: "Jamaica",
        日本: "Japan",
        乔丹: "Jordan",
        克什米尔: "Kashmir",
        哈萨克斯坦: "Kazakhstan",
        肯尼亚: "Kenya",
        科索沃: "Kosovo",
        科威特: "Kuwait",
        吉尔吉斯斯坦: "Kyrgyzstan",
        老挝: "Laos",
        老挝: "Lao PDR",
        拉脱维亚: "Latvia",
        黎巴嫩: "Lebanon",
        莱索托: "Lesotho",
        利比里亚: "Liberia",
        利比亚: "Libya",
        立陶宛: "Lithuania",
        卢森堡: "Luxembourg",
        马达加斯加: "Madagascar",
        马其顿: "Macedonia",
        马拉维: "Malawi",
        马来西亚: "Malaysia",
        马里: "Mali",
        毛里塔尼亚: "Mauritania",
        墨西哥: "Mexico",
        摩尔多瓦: "Moldova",
        蒙古: "Mongolia",
        黑山共和国: "Montenegro",
        摩洛哥: "Morocco",
        莫桑比克: "Mozambique",
        缅甸: "Myanmar",
        纳米比亚: "Namibia",
        荷兰: "Netherlands",
        新喀里多尼亚: "New Caledonia",
        新西兰: "New Zealand",
        尼泊尔: "Nepal",
        尼加拉瓜: "Nicaragua",
        尼日尔: "Niger",
        尼日利亚: "Nigeria",
        朝鲜: "Korea",
        北塞浦路斯: "NorthernCyprus",
        挪威: "Norway",
        阿曼: "Oman",
        巴基斯坦: "Pakistan",
        巴拿马: "Panama",
        巴布亚新几内亚: "Papua New Guinea",
        巴拉圭: "Paraguay",
        秘鲁: "Peru",
        刚果: "Republi cofthe Congo",
        菲律宾: "Philippines",
        波兰: "Poland",
        葡萄牙: "Portugal",
        波多黎各: "Puerto Rico",
        卡塔尔: "Qatar",
        塞尔维亚共和国: "RepublicofSerbia",
        罗马尼亚: "Romania",
        俄罗斯: "Russia",
        卢旺达: "Rwanda",
        萨摩亚: "Samoa",
        沙特阿拉伯: "Saudi Arabia",
        塞内加尔: "Senegal",
        塞尔维亚: "Serbia",
        塞拉利昂: "Sierra Leone",
        斯洛伐克: "Slovakia",
        斯洛文尼亚: "Slovenia",
        所罗门群岛: "SolomonIs",
        索马里兰: "Somaliland",
        索马里: "Somalia",
        南非: "South Africa",
        南乔治亚和南桑德威奇群岛: "S.Geo.andS.Sandw.Is",
        南苏丹: "S.Sudan",
        西班牙: "Spain",
        斯里兰卡: "Sri Lanka",
        苏丹: "Sudan",
        苏里南: "Suriname",
        斯威士兰: "Swaziland",
        瑞典: "Sweden",
        瑞士: "Switzerland",
        叙利亚: "Syria",
        塔吉克斯坦: "Tajikistan",
        坦桑尼亚: "Tanzania",
        泰国: "Thailand",
        东帝汶: "Timor-Leste",
        多哥: "Togo",
        特立尼达和多巴哥: "TrinidadandTobago",
        突尼斯: "Tunisia",
        土耳其: "Turkey",
        土库曼斯坦: "Turkmenistan",
        乌干达: "Uganda",
        乌克兰: "Ukraine",
        沙特阿拉伯: "United Arab Emirates",
        大不列颠联合王国: "United Kingdom",
        坦桑尼亚联合共和国: "UnitedRepublicofTanzania",
        美国: "United States",
        美利坚合众国: "UnitedStatesofAmerica",
        乌拉圭: "Uruguay",
        乌兹别克斯坦: "Uzbekistan",
        瓦努阿图: "Vanuatu",
        委内瑞拉: "Venezuela",
        越南: "Vietnam",
        西岸: "WestBank",
        西撒哈拉: "W.Sahara",
        也门共和国: "Yemen",
        赞比亚: "Zambia",
        津巴布韦: "Zimbabwe",
      };
      let mapName = "world_old";
      let geoCoordMap = data.geoCoordMap;
      let nationalPlate = data['nationalPlate'];
      for (let key in geoCoordMap) {
        let num = geoCoordMap[key][0] * 1;
        if (num < -35) {
          geoCoordMap[key][0] = num + 360;
        }
      }
      data = data['listCity'];
      let convertData = function (data) {
        let res = [];
        for (let i = 0; i < data.length; i++) {
          let geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value),
            });
          }
        }
        return res;
      };
      let regionsList = [];
      nationalPlate.forEach((item)=>{
        regionsList.push({
          name: item,
          label: {
            show: true,
            color: "#fff",
          },
          itemStyle: {
            areaColor: '#AFBFEA',
            shadowColor: 'rgb(187,187,187)',
            shadowBlur: 6,
          }
        })
      })
      let option = {
        tooltip: {
          trigger: 'item',
// 			backgroundColor: 'rgba(166, 200, 76, 0.82)',
          borderColor: '#002076',
          borderWidth: 1,
          showDelay: 0,
          hideDelay: 0,
          enterable: true,
          backgroundColor: '#fff',
          transitionDuration: 0,
          extraCssText: 'z-index:100',
          formatter: function(params, ticket, callback) {
            //根据业务自己拓展要显示的内容
            var res = "";
            var name = params.name;
            var value = params.value[2];
            // res = "<span style='color:#fff;'>" + name + "</span><br/>数据：" + params.value[2];
            res = "<span style='color:#002076;'>" + name +'：'+value;
            if (!!name)
              return res;
          }
        },
        backgroundColor:"white",
        // backgroundColor: "#dce3ea",
        // tooltip: {
        //   padding: 0,
        //   enterable: true,
        //   transitionDuration: 1,
        //   textStyle: {
        //     color: "#000",
        //     decoration: "none",
        //   },
        //   formatter: function (params) {
        //     return "";
        //   },
        // },

        geo: {
          show: true,
          map: mapName,
          nameMap: this.laguage == "CH" ? "" : nameMap,
          zoom: 1.2,
          label: {
            // show: true,
            fontSize: 14,
            emphasis: {
              show: true,
              color: '#333333'
            }
          },
          roam: false,
          itemStyle: {
            normal: {
              color: 'rgba(226, 231, 249)', //地图背景色
              borderColor: 'white', //省市边界线00fcff 516a89
              borderWidth: 2
            },
            emphasis: {
              color: '#AFBFEA' //悬浮背景
            }
          },
          // itemStyle: {
          //   normal: {
          //     areaColor: "#d4dae0",
          //     borderColor: "#fff",
          //   },
          //   emphasis: {
          //     areaColor: "#f9fbfd",
          //     borderColor: "#22D695",
          //   },
          // },

          regions: regionsList
        },
        series: [
          {
            name: "Top 5",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: convertData(
              data.sort(function (a, b) {
                return b.value - a.value;
              })
            ),
            symbolSize: 12,
            showEffectOn: "render",
            // rippleEffect: {
            //   brushType: "stroke",
            // },
            rippleEffect: { //涟漪特效
              color: '#3bffb2',
              period: 4, //动画时间，值越小速度越快
              brushType: 'stroke', //波纹绘制方式 stroke, fill
              scale: 3 //波纹圆环最大限制，值越大波纹越大
            },
            hoverAnimation: true,
            label: {
              show: false,
              position: 'right', //显示位置
              offset: [5, 0], //偏移设置
              formatter: function(params){//圆环显示文字
                return params.data.name;
              },
              fontSize: 13,
              color: '#8b96ad'
            },
            // label: {
            //   normal: {
            //     show: false,
            //     formatter: "{b}",
            //     position: "left",
            //   },
            // },
            itemStyle: {
              normal: {
                show: false,
                color: '#98ffda',
                shadowBlur: 10,
                shadowColor: "#98ffda",
              }
            },
            emphasis: {
              label: {
                show: false
              },
              itemStyle: {
                color: '#98ffda',
                borderWidth: 2,
                borderColor: '#22D695'
              },

            },
            // itemStyle: {
            //   normal: {
            //     color: "#AFBFEA",
            //     shadowBlur: 10,
            //     shadowColor: "#AFBFEA",
            //   },
            // },
            zlevel: 1,
          },
        ],
      };
      this.myEcharts.setOption(option, true);
    },
    handleClick(param) {},
    resize() {
      this.myEcharts.resize();
    },
    toThousands(num) {
      return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    },
  }
};
</script>

<style lang="less" scoped>
.count-box {
  width: 100%;
  height: calc(100vh - 126px);
  background: #eef1f8;
  overflow: hidden;
  position: relative;
  //padding-top: 60px;
  h2 {
    padding: 25px 0 20px;
    text-align: center;
    font-size: 40px;
    font-weight: normal;
    font-family: PingFangSC-Medium;
    color: #1d1d1d;
  }
  .map-wrap{
    //width: 100%;
    height: calc(100% - 120px);
    display: flex;
    align-items: center;
    background: white;
    border-radius: 20px;
    margin: 0 50px;
    box-shadow: 6px 6px 10px 2px rgba(218, 224, 237, .8);
  }

  .chart-map {
    width: 90%;
    height: 100%;
    padding-left: 20px;
  }
  .legend {
    //margin-top: -20px;
    //position: absolute;
    //display: flex;
    //justify-content: center;
    flex: 1;
    width: 100%;
    z-index: 10;
    margin-right: 20px;
    border-radius: 10px;
    border: 1px solid #e0e6f0;
    box-shadow: 6px 6px 10px 2px rgba(218, 224, 237, .8);
    padding-top: 1rem;
    > div {
      margin: 0 20px;
      p:nth-child(1) {
        text-align: center;
        color: #22d695;
        font-family: PingFangSC-Medium;
        font-size: 28px;
        margin-bottom: 0;
        span {
          font-size: 18px;
        }
      }
      p:nth-child(2) {
        text-align: center;
        color: #555;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        margin-bottom: 2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/visitors.vue